import "./firebase-app";

import type { JSX } from "react";
import { PropsWithChildren } from "react";

import {
  AnalyticsEventProvider,
  AnalyticsUserPersistenceProvider,
  FirebaseABTestingUserPropertiesProvider,
  PreferencesGAUserPropertiesProvider,
} from "./analytics";
import { AuthProvider } from "./auth";
import { FirestoreProvider } from "./firestore";
import { RemoteConfigProvider } from "./remote-config";

export function FirebaseProvider({ children }: PropsWithChildren): JSX.Element {
  return (
    <RemoteConfigProvider>
      <FirebaseABTestingUserPropertiesProvider>
        <PreferencesGAUserPropertiesProvider>
          <AnalyticsEventProvider>
            <AnalyticsUserPersistenceProvider>
              <AuthProvider>
                <FirestoreProvider>{children}</FirestoreProvider>
              </AuthProvider>
            </AnalyticsUserPersistenceProvider>
          </AnalyticsEventProvider>
        </PreferencesGAUserPropertiesProvider>
      </FirebaseABTestingUserPropertiesProvider>
    </RemoteConfigProvider>
  );
}
